import { render, staticRenderFns } from "./studentsgrouping.vue?vue&type=template&id=122e835d"
import script from "./studentsgrouping.vue?vue&type=script&lang=js"
export * from "./studentsgrouping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports